import Splide from '@splidejs/splide'

export default function () {
  const carousels = document.querySelectorAll(
      '.splide',
    );

		document.addEventListener( 'DOMContentLoaded', function() {
			carousels.forEach((carousel) => {
				new Splide(carousel, {
					arrows: true,
					pagination: true,
				}).mount()
			})
		} );
}
